var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal',{attrs:{"to":"header"}},[_vm._v(" Dashboard ")]),(!_vm.loading)?[_c('div',{staticClass:"q-pt-md"},[_vm._v(" "+_vm._s(_vm.$t('no_building'))+" ")])]:_vm._e(),_c('q-inner-loading',{attrs:{"showing":_vm.loading}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }